// Module
var code = `<div class="modal-dialog" role="document">
    <form data-bind="submit: save" autocomplete="off">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="icon-cancel"></i></button>
                <h4 class="modal-title" id="myModalLabel">Enter number of cores to be used by node <span data-bind="text: nodeTag"></span> </h4>
            </div>
            <div class="modal-body">
                <div class="padding padding-sm text-center">
                    <div class="row" data-bind="validationElement: maxUtilizedCores">
                        <div class="col-xs-12">
                            <div class="row">
                                <label class="control-label col-xs-4">Maximum cores to use:</label>
                                <div class="col-xs-8">
                                    <input autocomplete="off" type="number" class="form-control" min="1" data-bind="numericInput: maxUtilizedCores" id="max-utilized-cores" placeholder="Maximum cores that will be used">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12" data-bind="if: utilizedCores() && utilizedCores() != -1">
                            <label class="control-label col-xs-4">Utilized cores:</label>
                            <strong class="control-label col-xs-1"><span data-bind="text: utilizedCores"></span></strong>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12" data-bind="if: numberOfCores() && numberOfCores() != -1">
                            <label class="control-label col-xs-4">Available cores on node:</label>
                            <strong class="control-label col-xs-1"><span data-bind="text: numberOfCores"></span></strong>
                        </div>
                    </div>
                    <div class="bg-info padding padding-sm small flex-horizontal margin-top" data-bind="visible: warningText">
                        <div><i class="icon-info"></i></div>
                        <div data-bind="text: warningText"></div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-bind="click: \$root.close">Close</button>
                <button type="submit" data-bind="css: { 'btn-spinner': spinners.save }, disable: spinners.save" class="btn btn-primary"><span>Save</span></button>
            </div>
        </div>
    </form>
</div>
`;
// Exports
export default code;